import React, { Fragment, useState } from 'react';
import {
  Paper,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from '@mui/material';

import { PROTOCOL_TYPE } from '../../../utils/constants/common';
import NoDataFound from '../../../components/UI/NoDataFound';
import ICButton from '../../../components/UI/IconButton';
import IllustrationGuideSampleImg from '../../../assets/images/illustrationGuide.jpg';
import ViewImageModal from '../../UI/ViewImageModal';

const ProtocolList = (props) => {
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedIllustrationImg, setSelectedIllustrationImg] = useState(
    IllustrationGuideSampleImg
  );

  const openImage = (img) => {
    setSelectedIllustrationImg(img);
    setOpenImageModal(true);
  };

  const closeImage = () => {
    setOpenImageModal(false);
  };

  return (
    <Fragment>
      <Paper style={{ width: '100%' }} className="protocol-lists">
        <TableContainer className="table-max-height primary-table-color scroll-table-ipad-max-height">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Protocol</TableCell>
                <TableCell>Treatment Type</TableCell>
                {props.protocolType === PROTOCOL_TYPE.OTHER && (
                  <TableCell>Fitzpatrick Skin Type</TableCell>
                )}
                <TableCell>{`${
                  props.protocolType === PROTOCOL_TYPE.OTHER ? 'Premium Inventory' : 'Drug'
                } Name`}</TableCell>
                <TableCell>Area</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Measure</TableCell>
                <TableCell></TableCell>
                {props.noDelete === true && (
                  <TableCell className="action-table-cell"> Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {props.protocolList &&
                props.protocolList.map((row, index) => {
                  return (
                    <TableRow hover key={index}>
                      <TableCell className="primary-color cursor-pointer">{row.name}</TableCell>
                      <TableCell>{row.treatment}</TableCell>
                      {props.protocolType === PROTOCOL_TYPE.OTHER && (
                        <TableCell>{row.fitzpatrickSkinType}</TableCell>
                      )}
                      <TableCell>
                        {props.protocolType === PROTOCOL_TYPE.OTHER
                          ? row.premiumInventoryName
                          : row.drugName}
                      </TableCell>
                      <TableCell>{row.area}</TableCell>
                      <TableCell>{row.qty}</TableCell>
                      <TableCell>{row.measure}</TableCell>
                      <TableCell>
                        <img
                          src={row.illustrationImage}
                          onClick={() => openImage(row.illustrationImage)}
                          alt="illustration-guide-protocol-img"
                          className="attached-documents cursor-pointer"
                        />
                      </TableCell>
                      {props.noDelete === true && (
                        <TableCell>
                          <ICButton
                            title=""
                            type="button"
                            icon="fas fa-trash-alt"
                            style={{ margin: 8 }}
                            className="only-icon danger"
                            clickEvent={() => {
                              props.handleDeleteProtocol(index);
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              {(!props.protocolList || !props.protocolList.length) && (
                <NoDataFound hover colSpan={8} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <ViewImageModal
        open={openImageModal}
        title="Illustration Guide"
        onClose={closeImage}
        img={selectedIllustrationImg}
        alt="illustration-guide-sample-img"
      />
    </Fragment>
  );
};

export default ProtocolList;
